import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { cloneComponent } from '../../utils/cloneComponent.js';
import { isSpaceKey } from '../../utils/keyboard.js';
import { ItemWrapper } from './ItemWrapper.js';
import { Label } from './Label.js';
import { PostLabel } from './PostLabel.js';
import { CAN_BE_FOCUSED } from './constants.js';

function Link(_a) {
    var { isActive, label, icon, iconSize, postLabel, linkComponent, notificationIndicator, "data-testid": dataTestId } = _a, restLinkProps = __rest(_a, ["isActive", "label", "icon", "iconSize", "postLabel", "linkComponent", "notificationIndicator", "data-testid"]);
    const elementId = `element-${label}`;
    return (jsx("li", { "data-testid": dataTestId, role: "treeitem", children: jsxs(ItemWrapper, Object.assign({ "$isActive": isActive, color: "text.dmedium", component: linkComponent ? cloneComponent(linkComponent) : LinkUnstyled, href: "#", id: elementId, tabIndex: CAN_BE_FOCUSED, onClick: captureEvent, onKeyDown: captureEvent }, restLinkProps, { children: [jsx(Label, { icon: icon, iconSize: iconSize, isActive: isActive, label: label, notificationIndicator: notificationIndicator }), jsx(PostLabel, { postLabel: postLabel })] })) }));
}
function captureEvent(event) {
    const isSpacePressed = isSpaceKey(event);
    if (isSpacePressed) {
        event.preventDefault();
    }
    event.stopPropagation();
}
const LinkUnstyled = styled("a")({
    textDecoration: "none",
});

export { Link };
//# sourceMappingURL=Link.js.map
